import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.js';
import './styles.css';
import './theme.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('[hotline] #root element not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
